import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { AllCodeResponseHandler, BasicAsyncResponseSuccessHandler, MEDoNothingBasicResponseHandler, ResponseCode } from 'src/app/common/services/api/me-api-response';
import { MEAPIService } from 'src/app/common/services/api/me-api.service';
import { ChatRequestBean, ChatResponseBean } from './voice-command-bean';

@Injectable({
  providedIn: 'root'
})
export class VoiceCommandService {

  private readonly API_START_CHAT = MEAPIService.BASE_URL + '/customer/voiceCommand/startChat';
  public static readonly API_PERFORM_CHAT = MEAPIService.BASE_URL + '/customer/voiceCommand/chat';

  constructor(private srvApi: MEAPIService) { }

  public startChat(): AsyncSubject<void> {
    let ret = new AsyncSubject<void>();
    this.srvApi.Post(this.API_START_CHAT, null, [new BasicAsyncResponseSuccessHandler(ret)]);
    return ret;
  }

  public performChat(question: string): AsyncSubject<ChatResponseBean> {
    let bean: ChatRequestBean = { question };
    let ret = new AsyncSubject<ChatResponseBean>();
    this.srvApi.Post(VoiceCommandService.API_PERFORM_CHAT, bean, [new BasicAsyncResponseSuccessHandler(ret, ResponseCode.SUCCESS), new AllCodeResponseHandler(ret)]);
    return ret;
  }
}